import Icon from '../components/Icon.vue'

Icon.register({
  cheese: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 288h512v160c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-160zM299.8 32c118.2 6.2 212.2 104.1 212.2 224h-512l278.7-217c4.8-3.9 13.8-7 20-7 0.3 0 0.8 0 1.1 0z'
      }
    ]
  }
})
